import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ToggleLink from './ToggleLink'
import { MiniAppDiffTable } from './styled'
import ShowValue from './ShowValue'

const MiniAppAttributes = ({ miniApp }) => {
    const [show, setShow] = useState(false)
    const toggle = () => {
        setShow(!show)
    }

    return (
        <div key={miniApp.slug}>
            {miniApp.slug} <ToggleLink onClick={toggle} show={show} />
            {show && (
                <div>
                    <MiniAppDiffTable>
                        <thead>
                            <tr>
                                <th>Atributo</th>
                                <th>Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.getOwnPropertyNames(miniApp).map(prop => {
                                return (
                                    <tr key={prop}>
                                        <td>{prop}</td>
                                        <td>
                                            <ShowValue value={miniApp[prop]} />
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </MiniAppDiffTable>
                </div>
            )}
        </div>
    )
}

MiniAppAttributes.propTypes = {
    miniApp: PropTypes.object,
}

export default MiniAppAttributes
